<a class="pointer" appBackButton> < Volver</a>
<div class="jumbotron detail-body animated fadeIn fast">
  <div class="container-fluid" *ngIf="request">
    <div class="row mb-0">
      <div class="col-md-8">
        <h2 class="title">Detalle Solicitud {{ request.number }}</h2>
      </div>
      <!-- Solo si es Supervisor u Operador Banco -->
      <div
        *ngIf="(_auth.user.hasRole(1204) || _auth.user.isExecutive()) && !loading"
        class="col-md-4 text-right"
      >
        <a (click)="downloadRequest()" class="pointer no-underline"
          ><h5 class="primary">
            <img
              src="assets/images/requests/download.png"
              alt="Descargar planilla"
            /><b class="action">Descargar planilla</b>
          </h5></a
        >
      </div>
      <a [download]="request.name" id="download" hidden></a>
      <!-- Solo si es Supervisor u Operador Banco -->
    </div>
    <div class="row">
      <!-- Error -->
      <app-alert *ngIf="error" [alert]="error"></app-alert>
      
      <!-- Pendiente -->
      <app-alert-success
        *ngIf="approved && !sentReceipts" 
        [message]="'Fue aprobada exitosamente la solicitud ' + request.name"
        >
      </app-alert-success>
      <!-- Aprobada -->
      <app-alert-success
        *ngIf="sentReceipts" 
        [message]="getDynamicSuccessMessage()"
        >
      </app-alert-success>
      <!-- Aceptada -->
      <app-alert-success
        *ngIf="accepted" 
        [message]="'Fue aceptada exitosamente la solicitud ' + request.name"
        >
      </app-alert-success>
      <!-- Rechazada -->
      <app-alert *ngIf="rejected.rejected" [alert]="rejected.alert"></app-alert>
    </div>

    <app-loading [padding]="150" *ngIf="loading"></app-loading>
    
    <div *ngIf="!loading">
      <div class="row mt-30">
        <div class="col-md-6">
          <div class="row text-left">
            <div class="col col-md-5">
              <span>Ruc de la Empresa</span>
            </div>
            <div class="col col-md-7">
              <span
                ><b>{{ _auth.user.getUserData().idNumber }}</b></span
              >
            </div>
          </div>
          <div class="row text-left">
            <div class="col col-md-5">
              <span>Nombre / Razón social</span>
            </div>
            <div class="col col-md-7">
              <span
                ><b>{{ _auth.user.getUserData().companyName }}</b></span
              >
            </div>
          </div>
          <div class="row text-left">
            <div class="col col-md-5">
              <span>Nº de Solicitud</span>
            </div>
            <div class="col col-md-7">
              <span
                ><b>{{ request.number }}</b></span
              >
            </div>
          </div>
          <div class="row text-left">
            <div class="col col-md-5">
              <span>Nombre de la planilla</span>
            </div>
            <div class="col col-md-7">
              <span
                ><b>{{ request.name }}</b></span
              >
            </div>
          </div>
          <div class="row text-left">
            <div class="col col-md-5">
              <span>Tipo de planilla</span>
            </div>
            <div class="col col-md-7">
              <span
                ><b>{{ request.type.name }}</b></span
              >
            </div>
          </div>
          <div class="row text-left">
            <div class="col col-md-5">
              <span>Fecha carga de planilla</span>
            </div>
            <div class="col col-md-7">
              <span
                ><b>{{ request.date | date: "dd/MM/yyyy" }}</b></span
              >
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row text-left">
            <div class="col col-md-5">
              <span>Monto</span>
            </div>
            <div class="col col-md-7">
              <span
                ><b>{{ request.amount | currency:'':'' | customCurrency: request.currency }}</b></span
              >
            </div>
          </div>
          <div class="row text-left">
            <div class="col col-md-5">
              <span>Moneda</span>
            </div>
            <div class="col col-md-7">
              <span
                ><b>{{ request.currency }}</b></span
              >
            </div>
          </div>
          <div class="row text-left">
            <div class="col col-md-5">
              <span>Cantidad de registros</span>
            </div>
            <div class="col col-md-7">
              <span
                ><b>{{ request.totalRecords | number }}</b></span
              >
            </div>
          </div>
          <div class="row text-left">
            <div class="col col-md-5">
              <span>Estado</span>
            </div>
            <div class="col col-md-7">
              <span
                ><b>{{ request.state.getName() | titlecase }}</b></span
              >
            </div>
          </div>
          <div class="row text-left">
            <div class="col col-md-5">
              <span>Responsable</span>
            </div>
            <div class="col col-md-7">
              <span
                ><b>{{ request.responsible | titlecase }}</b></span
              >
            </div>
          </div>
          <div class="row text-left" *ngIf="request.paymentMethod">
            <div class="col col-md-5">
              <span>Medio de pago</span>
            </div>
            <div class="col col-md-7">
              <span
                ><b>{{ request.paymentMethod.name | titlecase }}</b></span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="row text-left" *ngIf="request.canBeAccepted(_auth.user)">
        <div class="col-md-4">
          <form [formGroup]="paymentForm">
            <div class="form-group has-feedback">
              <label class="label-form" for="">Medio de pago</label>
              <select class="form-control" formControlName="paymentMethod">
                <option value="" disabled selected>Selecciona</option>    
                <option *ngFor="let method of paymentMethods" value="{{ method.value }}">{{ method.name | titlecase}}</option>   
              </select>
              <i class="glyphicon glyphicon-menu-down form-control-feedback custom-select-arrow"></i>
            </div>
          </form>
        </div>
      </div>

      <!-- Receipt Management -->
      <app-receipt-management
        [request]="request"
        (loading)="loading = $event"
        (error)="error = $event"
        *ngIf="canShowReceiptsManagment()"
      ></app-receipt-management>
  
      <!-- Actions -->
      <div class="row" [ngClass]="{'action-buttons': !canShowReceiptsManagment()}" *ngIf="request.canBeApproved(_auth.user)">
        <button (click)="handleApproveAction()" class="button button-approve form-control">
          Aprobar Solicitud
        </button>
        <button (click)="reject()" *ngIf="request.canBeRejected(_auth.user)" class="button button-reject form-control">Rechazar</button>
      </div>
      <div class="row" [ngClass]="{'action-buttons': !canShowReceiptsManagment()}" *ngIf="request.canSendReceipts(_auth.user)">
        <button (click)="sendReceipts()" class="button button-approve form-control">
          Enviar comprobantes 
        </button>
        <button (click)="reject()" *ngIf="request.canBeRejected(_auth.user) && canShowButtonRejectedForState(request.state.getName())" class="button button-reject form-control">Rechazar </button>
      </div>
      <div class="row" [ngClass]="{'action-buttons': !canShowReceiptsManagment()}" *ngIf="request.canBeAccepted(_auth.user)">
        <button (click)="confirmWithPaymentMethod()" [disabled]="paymentForm.invalid" class="button button-approve form-control">
          Aprobar Comprobantes
        </button>
      </div>
            
    </div>
  </div>
</div>
